export default __webpack_public_path__ + "static/media/num-1.819ee184.png";